import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M208.6 181.5C221.4 163.1 229 141 229 117 229 55.2 178.8 5 117 5S5 55.2 5 117s50.2 112 112 112c24 0 46.1-7.6 64.5-20.4l76.4 76.4 27.1-27.1-76.4-76.4zM27.4 117c0-49.5 40.1-89.6 89.6-89.6s89.6 40.1 89.6 89.6-40.1 89.6-89.6 89.6-89.6-40.1-89.6-89.6z"
})), 'SearchAltIcon');